/**
 * <kc-sale-offer-card> — blocks/kc-sale-offer-card.liquid.
 *
 * Countdown: the end date comes from the announcement bar's own
 * <countdown-timer data-date>, so the card and the bar never disagree; the
 * theme's Sale end date is the fallback. Shows "Endet in 12 T 10 Std 05 Min
 * 09 Sek", every second, and nothing once the sale is over. With
 * data-precision="hours" it stops at the hours: "Endet in 12 T 10 Std".
 *
 * "Zum Angebot": on phones, closes the step accordions (kc-accordion
 * mobile_closed — model and colour) and scrolls to the offer title (step 3).
 */

const MOBILE = window.matchMedia("(max-width: 768px)");

function parseDate(raw) {
  if (!raw) return null;
  // "2026-09-27 23:59" → a date the browser parses everywhere (Safari too).
  const iso = String(raw).trim().replace(" ", "T");
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

class KcSaleOfferCard extends HTMLElement {
  connectedCallback() {
    this.timer = this.querySelector("[data-offer-timer]");
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);

    this.querySelector("[data-offer-jump]")?.addEventListener("click", () => this.jumpToOffer());
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  get endDate() {
    const barTimer =
      document.querySelector("announcement-bar countdown-timer[data-date]") ||
      document.querySelector(".announcement-bar countdown-timer[data-date]") ||
      document.querySelector('[id*="announcement"] countdown-timer[data-date]');
    return parseDate(barTimer?.getAttribute("data-date")) || parseDate(this.dataset.fallbackDate);
  }

  tick() {
    if (!this.timer) return;
    const end = this.endDate;
    const ms = end ? end.getTime() - Date.now() : 0;
    if (ms <= 0) {
      this.timer.textContent = "";
      return;
    }
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor(totalSeconds / 3600) % 24;
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const seconds = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, "0");
    const { labelEnds = "", labelDays = "T", labelHours = "Std", labelMinutes = "Min", labelSeconds = "Sek" } = this.dataset;
    if (this.dataset.precision === "hours") {
      this.timer.textContent = `${labelEnds} ${days} ${labelDays} ${hours} ${labelHours}`.trim();
      return;
    }
    this.timer.textContent = `${labelEnds} ${days} ${labelDays} ${pad(hours)} ${labelHours} ${pad(minutes)} ${labelMinutes} ${pad(seconds)} ${labelSeconds}`.trim();
  }

  jumpToOffer() {
    if (MOBILE.matches) {
      document.querySelectorAll("details[data-kc-open-key]").forEach((details) => {
        if (!details.hasAttribute("open")) return;
        details.removeAttribute("open");
        if ("_open" in details) details._open = false;
        details.setAttribute("aria-expanded", "false");
        const state = window.kcAccordionOpenState || (window.kcAccordionOpenState = {});
        state[details.getAttribute("data-kc-open-key")] = false;
      });
    }

    const target = document.querySelector(".upsell-block__title") || document.querySelector("kc-upsell");
    if (!target) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // Wait a frame so the closed steps have collapsed before measuring.
    requestAnimationFrame(() => {
      target.scrollIntoView({ block: "start", behavior: reduced ? "instant" : "smooth" });
    });
  }
}

if (!customElements.get("kc-sale-offer-card")) {
  customElements.define("kc-sale-offer-card", KcSaleOfferCard);
}
